import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
import { OASIS } from '../../oasis-types';
import { fieldSetValidate, isActive, isTimepoint } from '../util';
import { SectionE } from '../../oasis-sections/section-e';
/**
 *
 * Note: if there's an overlapping error for a particular field this is the order in which they'll be displayed
 * form level
 * section level
 * field level
 * base level: same level as "field", but uses built int zod validations
 */
// eslint-disable-next-line
export const sectionEConsistency = ({ input, ctx, version, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    // form level
    const payload = input;
    if (isActive(SectionE.m1740, version, payload.SectionA?.m0100) &&
        isTimepoint([OASIS.SOC, OASIS.ROC, OASIS.DSCH], payload?.SectionA?.m0100)) {
        const m1740 = payload.SectionDE?.m1740;
        // E-consistency-4400 If M1740_BD_NONE=[0], then at least one active item from M1740_BD_MEM_DEFICIT through M1740_BD_DELUSIONS must equal [1].
        if (!m1740 || !m1740?.length) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-4400 If 7 is not selected, then at least one active item from 1 through 6 must be checked.`,
                path: ['SectionDE', 'm1740'],
            });
        }
        // E-consistency-4410 If M1740_BD_NONE=[1], then all active items from M1740_BD_MEM_DEFICIT through M1740_BD_DELUSIONS must equal [0].
        if (fieldSetValidate({
            input: m1740,
            ifChecked: ['BD_NONE'],
            notChecked: ['BD_MEM_DEFICIT', 'BD_IMP_DECISN', 'BD_VERBAL', 'BD_PHYSICAL', 'BD_SOC_INAPPRO', 'BD_DELUSIONS'],
        })) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-4410 If 7 is selected, then all active items from 1 through 6 must not be checked`,
                path: ['SectionDE', 'm1740'],
            });
        }
    }
};
// E-consistency-4400 If M1740_BD_NONE=[0], then at least one active item from M1740_BD_MEM_DEFICIT through M1740_BD_DELUSIONS must equal [1].
// E-consistency-4410 If M1740_BD_NONE=[1], then all active items from M1740_BD_MEM_DEFICIT through M1740_BD_DELUSIONS must equal [0].
